import { render, staticRenderFns } from "./ArchivoForm.vue?vue&type=template&id=b8852368&"
import script from "./ArchivoForm.vue?vue&type=script&lang=js&"
export * from "./ArchivoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports